import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';

/** A hero's name can't match the given regular expression */
export function validarEmailMibanco(nameRe: RegExp): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    const forbidden = nameRe.test(control.value);
    return !forbidden ? {'validarEmailMibanco': {value: control.value}} : null;
  };
}

@Directive({
  selector: '[appValidarEmailMiBanco]',
  providers: [{provide: NG_VALIDATORS, useExisting: ForbiddenValidatorDirective, multi: true}]
})
export class ForbiddenValidatorDirective implements Validator {
  @Input('appValidarEmailMiBanco') forbiddenName: string;

 

  validate(control: AbstractControl): {[key: string]: any} {
    return this.forbiddenName ? validarEmailMibanco(new RegExp(this.forbiddenName, 'i'))(control)
                              : null;
  }
}
